import { useState } from 'react';

const faqs = [
  {
    q: '自拍和偷拍有什么区别？',
    a: '自拍是指拍摄者自己作为被摄对象的摄影方式，通常使用前置摄像头或三脚架配合定时器完成。偷拍（或称抓拍）是指在自然状态下捕捉他人真实瞬间的摄影技巧，强调在不打扰被摄者的情况下记录最真实的画面，常见于街头摄影和人文纪实领域。',
  },
  {
    q: '新手入门摄影需要买什么设备？',
    a: '对于新手来说，建议从手机摄影开始。现代旗舰手机的相机功能已经非常强大，完全能满足日常自拍和抓拍需求。当技术提升后，可以根据个人需求考虑入门级微单相机，搭配一支大光圈定焦镜头，性价比最高。',
  },
  {
    q: '如何快速提升自拍水平？',
    a: '三个关键点：第一，掌握基本构图法则，如黄金分割和三分法；第二，找到适合自己脸型的最佳拍摄角度；第三，学会利用自然光。每天坚持练习，一个月内就能看到明显进步。我们的网站上有系统的教程帮助你一步步提升。',
  },
  {
    q: '街头抓拍是否涉及隐私问题？',
    a: '在中国，公共场合拍摄一般不违法，但需要注意尊重他人隐私和肖像权。建议：拍摄时保持低调和礼貌，如果被摄者明确表示不愿意被拍，应立即停止并删除照片。如果照片用于商业用途，必须获得被摄者的书面授权。',
  },
  {
    q: '后期处理软件推荐哪个？',
    a: '手机端推荐Adobe Lightroom手机版和Snapseed，两者都是免费且功能强大的专业级工具。电脑端推荐Lightroom Classic和Capture One。对于新手来说，Lightroom手机版是入门的最佳选择，操作直观且学习曲线平缓。',
  },
  {
    q: '拍得好的教程适合什么水平的摄影师？',
    a: '我们的教程涵盖从零基础入门到进阶提升的各个阶段。无论你是刚拿起手机的新手，还是有一定经验的摄影爱好者，都能在这里找到适合自己的内容。每篇文章都标注了难度级别和阅读时间，方便你根据自己的水平选择。',
  },
];

export default function HomeFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm">
            关于自拍抓拍摄影的常见疑问解答
          </p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">
                  {faq.q}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-500 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`px-5 overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'pb-4 max-h-96' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}